import React from 'react'
import { Link } from 'react-router-dom'
import { COMPANY_INFO } from '../lib/constants'

export default function PageHeader({ badge, title, subtitle, breadcrumb }) {
  return (
    <div className="relative bg-gradient-to-r from-[#141628] via-[#1A1D37] to-[#121321] text-white py-14 sm:py-20 px-4 sm:px-6 overflow-hidden border-b border-[#252B66]/60">
      {/* Soft brand glow matching van colors */}
      <div
        className="absolute top-0 right-1/4 w-96 h-96 bg-[#252A6E]/20 rounded-full blur-3xl pointer-events-none"
        aria-hidden="true"
      />

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Breadcrumb */}
        <nav className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-[#9FA6D9] mb-4" aria-label="Brødkrumme">
          <Link to="/" className="hover:text-white transition-colors">Forside</Link>
          <span className="text-white/20">/</span>
          <span className="text-[#E0E4FF]">{breadcrumb || title}</span>
        </nav>

        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6">
          <div className="max-w-3xl space-y-3">
            {badge && (
              <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-[#B5BBE8] bg-[#252A6E]/50 border border-[#3C449E]/40 px-3.5 py-1 rounded-full">
                <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                <span>{badge}</span>
              </span>
            )}
            <h1 className="text-3xl sm:text-5xl font-extrabold tracking-tight text-white leading-tight">
              {title}
            </h1>
            {subtitle && (
              <p className="text-[#9FA6D9] text-sm sm:text-base max-w-2xl leading-relaxed">
                {subtitle}
              </p>
            )}
          </div>

          <div className="shrink-0 flex items-center gap-3">
            <a
              href={`tel:${COMPANY_INFO.phoneRaw}`}
              className="inline-flex items-center gap-2.5 rounded-full bg-[#E36C0A] hover:bg-[#B95000] text-white font-bold px-6 py-3 shadow transition-colors text-xs uppercase tracking-wider whitespace-nowrap"
            >
              <i className="fa-solid fa-phone text-xs" aria-hidden="true" />
              <span>Ring: {COMPANY_INFO.phone}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
